import fragmentShader from './build/frag.js';
import vertexShader from './build/vert.js';


let context = {
    canvas: null,
    gl: null,

    // Width and height of canvas in pixels
    width: 0,
    height: 0,

    // Current and next texture
    current: null,
    next: null,

    // Program and framebuffer
    program: null,
    framebuffer: null,

    // Uniforms
    uniforms: {},
    state: {},
}



function doResize(width, height) {
    const {canvas, gl, uniforms} = context;

    context.width = width;
    context.height = height;
    canvas.setAttribute('width', width);
    canvas.setAttribute('height', height);
    gl.viewport(0, 0, width, height);
    gl.uniform2f(uniforms.resolution, width, height);
}



function createShader(type, source) {
    const {gl} = context;

    let shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);

    let success = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    if (success) {return shader;}

    // Log failure
    console.error(gl.getShaderInfoLog(shader));
    gl.deleteShader(shader);
}


function createProgram() {
    const {gl} = context;

    let vert = createShader(gl.VERTEX_SHADER, vertexShader);
    let frag = createShader(gl.FRAGMENT_SHADER, fragmentShader);

    const program = gl.createProgram();
    context.program = program;

    gl.attachShader(program, vert);
    gl.attachShader(program, frag);
    gl.linkProgram(program);

    let success = gl.getProgramParameter(program, gl.LINK_STATUS);
    if (success) {gl.useProgram(program);}

    // Log failure
    console.error(gl.getProgramInfoLog(program));
    gl.deleteProgram(program);
}


function createScreen() {
    const {gl, program} = context;

    // Initialize vertex position buffers
    let positionAttr = gl.getAttribLocation(program, 'a_position');
    let positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);

    gl.enableVertexAttribArray(positionAttr);
    gl.vertexAttribPointer(positionAttr, 2, gl.FLOAT, false, 0, 0);

    // Create two triangles covering entire canvas
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
        -1, -1, 1, -1, -1, 1,
        -1, 1, 1, -1, 1, 1
    ]), gl.STATIC_DRAW);
}



// Texture initialization
function initTexture(contents) {
    const {gl, width, height} = context;

    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);

    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);

    gl.texImage2D(
        gl.TEXTURE_2D, 0, gl.RGBA,
        width, height, 0,
        gl.RGBA, gl.UNSIGNED_BYTE,
        new Uint8Array(contents)
    );

    return texture;
}



// GL Utils
function createUniforms() {
    const {gl, state, uniforms, program} = context;

    // Initialize float uniforms
    for (let [key, value] of Object.entries(state)) {
        uniforms[key] = gl.getUniformLocation(program, 'u_' + key);
        gl.uniform1f(uniforms[key], value);
    }

    // Initialize resolution uniform
    uniforms.resolution = gl.getUniformLocation(program, 'u_resolution');
}

function setState(name, value) {
    const {gl, state, uniforms} = context;
    state[name] = value;
    gl.uniform1f(uniforms[name], value);
}

function initGL(canvas) {
    context.canvas = canvas;
    context.gl = canvas.getContext('webgl');

    createProgram();
    createScreen();

    context.framebuffer = context.gl.createFramebuffer();

    createUniforms();
}

export {context, initGL, setState, initTexture, doResize};
